import ChipColors from './ChipColors';

export default [
  {
    value: 'A',
    text: 'Ativo',
    ...ChipColors.success,
  },
  {
    value: 'I',
    text: 'Inativo',
    ...ChipColors.warning,
  },
  {
    value: 'D',
    text: 'Deleção solicitada',
    ...ChipColors,
  },
];
